var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M27,56.86,71.88,20.69,72,33.41a2.1,2.1,0,0,0,4.2,0L76,13.5l-19.88.12a2.1,2.1,0,0,0,0,4.2l12.72-.08-44.35,36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6,41.85V53.46H38.73V68.19H16.86V85.5H87.14V41.85Zm-39.08,31H38.73v8H21.52Zm21.87,8V58.12H60.6V80.84Zm39.09,0H65.27V46.51H82.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowRevenue);
export default __webpack_public_path__ + "static/media/growRevenue.733aeb524b950ca53bcbcb6fd502a5dc.svg";
export { ForwardRef as ReactComponent };